// packages/api/src/axios-client.ts
import axios from 'axios';
import { handle401, handle401IgReauth } from './handle401';

const baseURL = process.env.SSO_PUBLIC_API_URL || 'https://app.atajoy.com/sapi/api';
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
export const axiosClientWithAuth = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...(isLocalhost && { 'fromlocal': 'true' })
  },
  //  بسیار مهم: فعال کردن ارسال/دریافت کوکی‌ها
  withCredentials: true
});

//  Request interceptor برای اضافه کردن token از cookie
axiosClientWithAuth.interceptors.request.use(
  (config) => {
 
    return config;
  },
  (error) => {
    console.error(' [axiosClient] Request error:', error);
    return Promise.reject(error);
  }
);

//  Response interceptor برای هندل کردن خطاها
axiosClientWithAuth.interceptors.response.use(
  (response) => {
    console.log(' [axiosClient] Response success:', response.config.url);
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401 && data?.error === 'reauth_flow') {
        handle401IgReauth(); // central handler
      }
      if (status === 401 && data?.error !== 'reauth_flow') {
        handle401(); // central handler
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClientWithAuth;